import { render } from "./App.vue?vue&type=template&id=d1913e58"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d1913e58&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__